module.exports = __webpack_public_path__ + "static/media/loupe.7d7fbfe4.png";